import React from 'react';

import { cn } from '../../helpers/cn';

const baseClasses =
  'inline-flex items-center justify-center whitespace-nowrap rounded-lg text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:bg-neutral-gray-300 disabled:text-white';

const variantClasses = {
  default:
    'bg-brandcolora text-brandcolora-foreground hover:bg-brandcolora/90',
  destructive:
    'bg-destructive text-destructive-foreground hover:bg-destructive/90',
  outline: 'border border-input bg-transparent hover:bg-accent',
  secondary: 'bg-secondary text-secondary-foreground hover:bg-secondary/80',
  ghost: 'hover:bg-accent hover:text-accent-foreground',
  link: 'underline-offset-4 text-brandcolora underline'
};

const sizeClasses = {
  default: 'h-[48px] px-4 lg:px-[30px] py-2 lg:text-base',
  sm: 'h-9 rounded-lg px-4 lg:px-[20px]',
  lg: 'h-11 rounded-lg px-8',
  icon: 'h-10 w-10'
};

function buttonVariants({ variant = 'default', size = 'default', className } = {}) {
  return cn(
    baseClasses,
    variantClasses[variant] ?? variantClasses.default,
    sizeClasses[size] ?? sizeClasses.default,
    className
  );
}

const Button = React.forwardRef(
  ({ className, variant, size, ...props }, ref) => (
    <button
      className={buttonVariants({ variant, size, className })}
      ref={ref}
      {...props}
    />
  )
);
Button.displayName = 'Button';

export { Button, buttonVariants };
